<template>
  <b-dropdown class="list-dropdown" ref="dropdown" variant="link" block no-caret :disabled="disabled">
    <template v-slot:button-content>
      <div class="custom-select text-left">
        <span v-if="!busy" :title="selected ? selected.name : ''" class="selected">
          <i v-if="selected" class="fa fa-fw fa-file-pdf"></i>
          {{ selected ? selected.name : placeholder }}
        </span>
        <span v-if="busy">
          <i class="fa fa-fw fa-circle-notch fa-spin"></i>
          {{ trans('please_wait') }}
        </span>
      </div>
    </template>
    <b-dropdown-text>
      <b-form-input ref="search" type="search" v-model="search" size="sm" :debounce="500" :placeholder="trans('search')" :disabled="busy" />
    </b-dropdown-text>
    <b-dropdown-text v-if="!!error" variant="danger">
      {{ error }}
    </b-dropdown-text>
    <b-dropdown-text v-if="busy && items == null">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </b-dropdown-text>
    <b-dropdown-item v-for="item in items" v-bind:key="item.id" :active="item.id == value" :disabled="disabled || busy" @click="onClickItem(item)">
      <i class="fa fa-fw fa-file-pdf"></i>
      <span>{{ item.name }}</span>
      <small class="text-muted">{{ item.human_readable_size }}</small>
    </b-dropdown-item>
    <b-dropdown-divider></b-dropdown-divider>
    <b-dropdown-text>
      <b-row>
        <b-col class="text-center">
          <b-button variant="link" class="p-0" :disabled="disabled || busy || page == 1" @click="onPreviousPage">
            <i class="fa fa-fw fa-chevron-left"></i>
          </b-button>
        </b-col>
        <b-col v-if="nullable" class="text-center">
          <b-button variant="link" class="p-0 text-danger" :disabled="disabled || busy || !value" :title="trans('clear')" v-b-tooltip.hover @click="onClear">
            <i class="fa fa-fw fa-times"></i>
          </b-button>
        </b-col>
        <b-col class="text-center">
          <b-button variant="link" class="p-0" :disabled="disabled || busy || page == last_page" @click="onNextPage">
            <i class="fa fa-fw fa-chevron-right"></i>
          </b-button>
        </b-col>
      </b-row>
    </b-dropdown-text>
  </b-dropdown>
</template>

<style>
  .list-dropdown.b-dropdown>button {
    padding: 0;
  }
</style>

<script>
  export default {
    props: {
      organization: Object,
      value: {
        type: Number,
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      nullable: {
        type: Boolean,
        default: false,
      },
      placeholder: {
        type: String,
        default: trans('choose_a_document'),
      },
      initial_short_url: String,
    },
    data() {
      return {
        trans: trans,
        numeral: numeral,
        busy: false,
        error: null,
        items: null,
        selected: null,
        staff: null,
        total: null,
        page: 1,
        last_page: 1,
        per_page: 10,
        search: null,
      }
    },
    computed: {
      initial_umid() {
        return this.initial_short_url ? this.initial_short_url.split('/').pop() : null
      },
    },
    watch: {
      search() {
        this.page = 1
        this.fetch().then(() => {
          this.$refs.search.focus()
        })
      },
      value() {
        if (!this.value && !!this.selected) {
          this.onClear()
          return
        }
        if (this.value && !this.selected || this.selected.id != this.value) {
          let item = _.find(this.items || [], {id: this.value})
          if (!!item) {
            this.selected = item
          } else {
            this.fetch()
          }
        }
      },
    },
   	methods: {
      refresh() {
        this.fetch()
      },
      onClear() {
        this.selected = null
        this.$emit('input', null)
        this.$emit('document', null)
        this.$refs.dropdown.hide(true)
      },
      onPreviousPage(bvEvt) {
        if (this.page <= 1) return
        this.page -= 1
        this.fetch()
      },
      onNextPage(bvEvt) {
        if (this.page >= this.last_page) return
        this.page += 1
        this.fetch()
      },
      onClickItem(item) {
        this.selected = item
        this.$emit('input', item.id)
        this.$emit('document', item, {source: 'user'})
      },
   	  fetch(firstTime) {
        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/media/document?per_page=${this.per_page}&page=${this.page}`
        if (this.search) url += `&name=${encodeURIComponent(this.search)}`
        if (this.value) url += `&selected=${this.value}`
        else if (firstTime && this.initial_umid) url += `&selected_umid=${this.initial_umid}`
        return axios.get(url)
        .then(response => {
          this.busy = false
          this.total = response.data.total
          this.page = response.data.current_page
          this.last_page = response.data.last_page
          this.items = response.data.data
          if (response.data.selected) {
            if (this.value != response.data.selected.id) this.$emit('input', response.data.selected.id)
            this.selected = response.data.selected
          }
          this.$emit('loaded')
          if (this.selected) this.$emit('document', this.selected, {source: 'fetch'})
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
   	  },
   	},
   	mounted() {
      window.documentDropdown = this
      this.fetch(true)
   	},
  }
</script>